import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { CardText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { Assets } from '@Utils/AssetsStore';
import { observer } from 'mobx-react-lite';

import { TextPositioner } from '../primitives/TextPositioner';

type Props = {
  item: GridCard<
    | PlaneTypes.Card_MultiSection_Description_Title
    | PlaneTypes.Card_MultiSection_Description_Title_Small
    | PlaneTypes.Card_MultiSection_Description_Title_Ultra_Small
    | PlaneTypes.Card_MultiSection_SectionHero_Small_Title
  >;
};

export const MultiSectionDescriptionTitle = observer(
  function MultiSectionDescriptionTitle({ item }: Props) {
    const getTextProps = (): CardTextProps => {
      if (
        item.type === PlaneTypes.Card_MultiSection_Description_Title_Ultra_Small
      ) {
        return {
          text: item.data?.title ?? '',
          color: 'black',
          fontSize: 26,
          fontAsset: Assets.Font_Gilroy_Bold,
          anchorX: 'left',
          anchorY: 'top',
          textAlign: 'left',
          maxWidth: item.size.width,
          position: { x: -item.size.width / 2 + 10, y: item.size.height / 2 },
        };
      }

      if (item.type === PlaneTypes.Card_MultiSection_SectionHero_Small_Title) {
        return {
          text: item.data?.title ?? '',
          color: 'black',
          fontSize: 26,
          fontAsset: Assets.Font_Gilroy_Bold,
          anchorX: 'left',
          anchorY: 'middle',
          textAlign: 'left',
          maxWidth: item.size.width,
          position: { x: -item.size.width / 2 + 10, y: 0 },
        };
      }

      // item.type === 'Card_MultiSection_Description_Title' ||
      // item.type === 'Card_MultiSection_Description_Title_Small'
      return {
        text: item.data?.title ?? '',
        color: 'black',
        fontSize: 48,
        fontAsset: Assets.Font_Gilroy_Bold,
        anchorX: 'center',
        anchorY: 'top',
        textAlign: 'center',
        maxWidth: item.size.width - 150,
        position: { x: 0, y: 0 },
      };
    };

    const textProps = getTextProps();

    if (!textProps.text) {
      return null;
    }

    return (
      <TextPositioner item={item}>
        <CardText {...getTextProps()} />
      </TextPositioner>
    );
  }
);
